import type { MouseEvent } from "react";
import { Box, ToggleButtonGroup, ToggleButton } from "@mui/material";
import ViewListIcon from "@mui/icons-material/ViewList";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { useSearchParams } from "react-router-dom";

type HouseVisitSlotsViewToggleProps = {
  /** Unused — kept for parity with CustomCalendarToolbar listToggleComponent props. */
  hideCreateButton?: boolean;
};

export function HouseVisitSlotsViewToggle(_props: HouseVisitSlotsViewToggleProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const viewParam = searchParams.get("tab") || "CALENDAR";

  const handleChange = (_e: MouseEvent<HTMLElement>, newValue: string | null) => {
    if (!newValue) return;
    const next = new URLSearchParams(searchParams);
    next.set("tab", newValue);
    setSearchParams(next);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        flexShrink: 0,
        minWidth: "fit-content",
      }}
    >
      <ToggleButtonGroup
        value={viewParam}
        exclusive
        onChange={handleChange}
        sx={{ ml: 1, display: "flex", alignItems: "center" }}
        size="small"
      >
        <ToggleButton value="CALENDAR" aria-label="calendar" sx={{ height: 40 }}>
          <CalendarMonthIcon />
        </ToggleButton>
        <ToggleButton value="LIST" aria-label="list" sx={{ height: 40 }}>
          <ViewListIcon />
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}

export default HouseVisitSlotsViewToggle;
